import setAttribute from 'utils/DOM/setAttribute'

function prepareDataToTrack(state) {
  const addOnsSelected = state.addOns

  const dentalAddOn = addOnsSelected.find(addOn => addOn.productId == 4)
  const latitudeAddOn = addOnsSelected.find(addOn => addOn.productId == 12)

  if (dentalAddOn) {
    setAttribute('#see-more-details-dental-addon', 'data-sp-value', dentalAddOn.planId)
    setAttribute('#view-brochure-dental-addon', 'data-sp-value', dentalAddOn.planId)
  }
  if (latitudeAddOn) {
    setAttribute(
      '#see-more-details-latitude-addon',
      'data-sp-value',
      latitudeAddOn.planId
    )
    setAttribute('#view-brochure-latitude-addon', 'data-sp-value', latitudeAddOn.planId)
  }
}

export default prepareDataToTrack
